<template>
  <form
    autocomplete="off"
    class="admin-equipment-categories-form"
    @reset.prevent="handleCancel"
    @submit.prevent="handleSave"
  >
    <fieldset>
      <label>
        <span class="required">Name</span>

        <input
          autofocus
          :disabled="disabled"
          id="admin-equipment-category-name"
          required
          type="text"
          v-model.trim="name"
        />
      </label>

      <label>
        <span>Name Fr</span>

        <input
          :disabled="disabled"
          id="admin-equipment-category-name-fr"
          type="text"
          v-model.trim="name_fr"
        />
      </label>
    </fieldset>

    <footer>
      <button
        :disabled="!isDeleteEnabled"
        id="admin-equipment-category-delete"
        type="button"
        @click="handleDelete"
        v-if="canDelete && category.id"
      >Delete</button>

      <button
        :disabled="!isSaveEnabled"
        id="admin-equipment-category-save"
        type="submit"
        v-if="canSave"
      >Save</button>

      <button
        :disabled="!isCancelEnabled"
        id="admin-equipment-category-cancel"
        type="reset"
        v-if="canCancel"
      >Cancel</button>
    </footer>
  </form>
</template>

<script>
import {
  deleteEquipmentCategory,
  saveEquipmentCategory
} from "../../api/EquipmentAPI";

export default {
  data() {
    return {
      name: undefined,
      name_fr: undefined,
    };
  },

  props: {
    category: {
      type: Object
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    canCancel() {
      return true;
    },
    canDelete() {
      return this.can("DELETE_EQUIPMENT_CATEGORIES");
    },
    canSave() {
      return this.can({
        permissions: [
          "CREATE_EQUIPMENT_CATEGORIES",
          "UPDATE_EQUIPMENT_CATEGORIES"
        ],
        matchAny: true
      });
    },
    isCancelEnabled() {
      return !this.disabled;
    },
    isDeleteEnabled() {
      return !this.disabled && this.category?.id && !this.category?.protected;
    },
    isSaveEnabled() {
      return (
        !this.disabled &&
        (this.category?.id
          ? this.can("UPDATE_EQUIPMENT_CATEGORIES")
          : this.can("CREATE_EQUIPMENT_CATEGORIES"))
      );
    }
  },

  methods: {
    handleCancel() {
      this.$emit("cancel");
    },
    async handleDelete() {
      if (
        !confirm("Are you sure you want to delete this equipment category?")
      ) {
        return;
      }

      await deleteEquipmentCategory(this.category);
      this.$emit("delete", this.category);
    },
    async handleSave() {
      try {
        this.$emit(
          "save",
          await saveEquipmentCategory({
            ...this.category,
            name: this.name,
            name_fr: this.name_fr,
          })
        );
      } catch (e) {
        this.showErrors(e, "An equipment category");
      }
    },
    isDirty() {
      if (this.disabled) {
        return false;
      }

      return this.name !== this.category?.name || this.name_fr !== this.category?.name_fr;
    }
  },

  watch: {
    category: {
      immediate: true,
      handler(to, from) {
        if (to !== from) {
          this.name = to?.name;
          this.name_fr = to?.name_fr;
        }

        !this.disabled && this.autofocus();
      }
    },
    disabled(to, from) {
      !to && from && this.autofocus();
    }
  }
};
</script>

<style>
.admin-equipment-categories-form {
  display: grid;
  grid-column-gap: 1em;
  grid-row-gap: 0.5em;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.admin-equipment-categories-form > footer {
  grid-column: span 2;
  margin: 0;
  padding: 0.5em 0 0 0;
}
</style>